import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const AuthCallback = () => {
  const { isAuthenticated, isLoading, handleRedirectCallback } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    const processCallback = async () => {
      if (!isLoading) {
        if (isAuthenticated) {
          // Obtener la URL guardada en appState
          try {
            const result = await handleRedirectCallback();
            const returnTo = result?.appState?.returnTo || '/dashboard';
            console.log('Redirigiendo a:', returnTo);
            navigate(returnTo, { replace: true });
          } catch (error) {
            // Si ya se procesó el callback, ir al dashboard
            console.log('Callback ya procesado, ir a dashboard');
            navigate('/dashboard', { replace: true });
          }
        } else {
          navigate('/login', { replace: true });
        }
      }
    };

    processCallback();
  }, [isAuthenticated, isLoading, navigate, handleRedirectCallback]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '1rem',
      backgroundColor: '#f5f3ff'
    }}>
      <div style={{ fontSize: '3rem' }}>✨</div>
      <p style={{ fontSize: '1.2rem', color: '#7c3aed', fontWeight: '600' }}>
        Completando inicio de sesión...
      </p>
      <div style={{
        width: '200px',
        height: '4px',
        backgroundColor: '#e5e7eb',
        borderRadius: '2px',
        overflow: 'hidden'
      }}>
        <div style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#7c3aed',
          animation: 'loading 1s ease-in-out infinite'
        }}></div>
      </div>
      <style>{`
        @keyframes loading {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
};

export default AuthCallback;
